<template>
    <div v-if="!loading">
        <note :title="$fieldTitle('Web', 'form', true)" :description="webFormMessage"/>
        <div class="row mt-primary">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-3 col-sm-12 pt-2">
                        <label>{{ $t('embed') }}</label>
                    </div>
                    <div class="col-md-9 col-sm-12">
                        <app-input
                            type="textarea"
                            v-model="embededCode"
                        />
                    </div>
                </div>
            </div>
            <div class="col-md-12">
                <div class="row mt-3">
                    <div class="col-md-3 col-sm-12 pt-2">
                        <label>{{ $t('direct_url') }}</label>
                    </div>
                    <div class="col-md-9 col-sm-12">
                        <app-input
                            type="text"
                            v-model="directUrl"
                        />
                    </div>
                </div>
            </div>
            <div class="col-md-12">
                <div class="row mt-3">
                    <div class="col-md-3 col-sm-12 pt-2">
                        <label>{{ $t('double_opt_in') }}</label>
                    </div>
                    <div class="col-md-9 col-sm-12">
                        <app-input id="appSettingsRegistration"
                                   type="radio-buttons"
                                   @input="handleNotifiable"
                                   v-model="formData.notification"
                                   :list="notification"/>
                    </div>
                </div>
            </div>


        </div>

    </div>
    <app-pre-loader v-else/>
</template>

<script>
import FormHelperMixins from "../../../../Mixins/Global/FormHelperMixins";
import AppFunction from "../../../../../core/helpers/app/AppFunction";
import Note from "../../../Helper/Note/Note";
import {axiosGet, axiosPost} from "../../../../Helpers/AxiosHelper";
import {
    brandPath,
    subscriber_api_url,
    web_form_subscriber_create,
    subscriber_notifiable
} from '../../../../config/apiUrl'
import {FormMixin} from "../../../../../core/mixins/form/FormMixin";

export default {
    name: "SubscriberWebForm",
    components: {Note},
    mixins: [FormHelperMixins, FormMixin],
    data() {
        return {
            api: {
                store: '',
                update: '',
                custom_fields: ''
            },
            formData: {},
            loading: true,
            showConfirmation: false,
            notification: [
                {id: true, value: 'Enable'},
                {id: false, value: 'Disable'}
            ],

        }
    },
    methods: {
        getSubscriberUrl(regenerate = false) {
            const url = regenerate ? `${subscriber_api_url}/1` : subscriber_api_url;
            axiosGet(url).then(({data}) => {
                this.api = data;
                this.formData.notification = data.notification_enable
            }).finally(() => {
                this.loading = false;
            })
        },
        handleNotifiable(value) {
            if (this.api.notification_enable !== value) {
                axiosPost(subscriber_notifiable, this.formData).then(({data}) => {
                    this.$toastr.s('', data.message);
                    this.getSubscriberUrl()

                })
                    .catch(({response}) => {
                        this.$toastr.e(response.message);


                    })
            }
        }
    },
    computed: {
        embededCode() {
            return `<iframe src="${AppFunction.getBaseUrl()}/${web_form_subscriber_create}" frameborder="0" allowfullscreen width="100%" height="500" ></iframe>`;
        },
        directUrl() {
            return `${AppFunction.getBaseUrl()}/${web_form_subscriber_create}`;
        },
        apiTabPage() {
            return `${AppFunction.getBaseUrl()}/${brandPath}/settings/page?tab=API`;
        },
        webFormMessage() {
            return `<ol><li>${this.$t('subscriber_web_form_warning')}</li><li>${this.$t('subscriber_web_form_message')} Or you can <a href="${this.directUrl}" target="_blank">click here</a>.</li><li>${this.$t('api_page_warning_message')} Or you can <a href="${this.apiTabPage}">click here</a>.</li><li>${this.$t('subscriber_opt_in_warning')}</li></ol>`;
        },

    },
    created() {
        this.getSubscriberUrl();
    }
}
</script>

<style scoped>
.feather-16 {
    width: 16px;
    height: 16px;
    cursor: pointer;
}
</style>
